import CheckoutIndividual from "./CheckoutIndividual";
import { removeDuplicate } from "../../utils/remove-duplicate/removeDuplicate";
import CartItem from "../../layouts/cart/CartAside";
import Empty from "../empty-state/Empty";

const Checkout = ({ carts, selectedAddress, deliveryOption }) => {
  const cart = removeDuplicate(carts, (i) => i.product.product_name);

  return (
    <div className="pb-10">
      <CartItem>
        {carts.length > 0 ? (
          <div>
            <h1 className="font-normal text-lg">Cart ({cart.length} items)</h1>
            <CheckoutIndividual
              carts={cart}
              selectedAddress={selectedAddress}
              deliveryOption={deliveryOption}
            />
          </div>
        ) : (
          <Empty />
        )}
      </CartItem>
    </div>
  );
};

export default Checkout;
